<template>
  <div class="Topics">
    <TopicsCategories />
    <div class="TopicsButtons">
      <Loader v-if="isLoading" :position="'center'" />
      <TopicButton
        v-else
        v-for="topic in getTopicsList"
        :key="topic.topicName"
        :topic="topic"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "./Loader";
import TopicsCategories from "./TopicsCategories";
import TopicButton from "./TopicButton";

export default {
  name: "Topics",
  components: {
    Loader,
    TopicsCategories,
    TopicButton,
  },
  async created() {
    await this.fetchTopics();
  },
  methods: {
    ...mapActions(["fetchTopics"]),
  },
  computed: {
    ...mapGetters(["getTopicsList"]),
    isLoading() {
      return Boolean(!this.getTopicsList);
    },
  },
};
</script>

<style lang="scss" scoped>
.Topics {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  min-height: 230px;
  width: 100%;
  margin: 20px auto 70px;
  padding: 30px;
  background-color: $color-background-light;
  border-radius: 40px;
  box-sizing: border-box;
}
.TopicsButtons {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 1200px) {
  .Topics {
    width: 100%;
  }
}

@media screen and (max-width: 650px) {
  .Topics {
    width: 100%;
    box-sizing: border-box;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 5px;
    margin: 20px 0 40px;
    border-radius: 20px;
  }
  .TopicsButtons {
    box-sizing: border-box;
    width: 100%;
  }
}
</style>
